import { gql } from '@apollo/client'
import React from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useScreensState = () => React.useContext(Context)
export const useScreens = () => useScreensState()?.screens

const QUERY = gql`
  query Screens {
    screens(filter: { screens: "dashboard" }, sort: { field: INSERTED_AT }) {
      id
      name
      data
      items {
        id
        name
        type
        data
        position
        size
      }
    }
  }
`

const ScreensLoader = ({ children }) => {
  const { data, ...state } = useQuery(QUERY, {
    client: generalClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ScreensLoader
